module.exports = __webpack_public_path__ + "img/foto-comum.920992ac.png";